import { useQuery } from '@tanstack/react-query';
import { uiApi } from '@/api/ui.api';
import { queryKeys, tierOptions } from '@/lib/query';

/**
 * Backend-driven workflow action flags. Frontend never decides approve/reject visibility.
 */
export function useWorkflowActions(
  ownerModule: string,
  entityType: string,
  entityId: number | null | undefined,
) {
  return useQuery({
    queryKey: queryKeys.ui.workflow(ownerModule, entityType, entityId ?? 0),
    queryFn: () => uiApi.workflow(ownerModule, entityType, entityId!),
    enabled: entityId != null && entityId > 0,
    ...tierOptions('operational'),
    select: (workflow) => (workflow?.instanceId ? workflow : undefined),
  });
}
